/* eslint-disable i18next/no-literal-string */
import { colors } from "~/components/landing/colors";

/**
 * Ported from bouncieweb's `LandingPageComponents/DrivingHistoryList.js`.
 *
 * A static mock of the app's trip-history card: blue date header, a trips/miles
 * subheader, then two trip rows. Each row shows start/end times and addresses
 * beside a red-dot → green-dot connector.
 *
 * Unlike `DrivingHistoryCarousel` (used by the family grid) this variant does not
 * animate — it is the flat list the Turo / Loaner / Nascar grids use.
 */

// TripEndpointsDots: red dot, connector line, green dot.
function TripEndpointsDots() {
  return (
    <div className="flex flex-col items-center justify-center gap-px">
      <div
        className="h-[5px] w-[5px] rounded-full"
        style={{ backgroundColor: colors.red2 }}
      />
      <div
        className="h-[14px] w-px"
        style={{ backgroundColor: colors.grayLight8 }}
      />
      <div
        className="h-[5px] w-[5px] rounded-full"
        style={{ backgroundColor: colors.green2 }}
      />
    </div>
  );
}

function Trip({
  startTime,
  endTime,
  startAddress,
  endAddress,
  distance,
}: {
  startTime: string;
  endTime: string;
  startAddress: string;
  endAddress: string;
  distance: string;
}) {
  return (
    // TripContainer
    <div className="flex items-center justify-between p-2 text-[10px]">
      <div className="flex items-center gap-[5px]">
        <TripEndpointsDots />
        {/* TripEndpointsContainer */}
        <div className="flex justify-between gap-[9px]">
          {/* Column */}
          <div className="flex flex-col justify-between gap-[5px]">
            <div>{startTime}</div>
            <div>{endTime}</div>
          </div>
          <div className="flex flex-col justify-between gap-[5px]">
            <div>{startAddress}</div>
            <div>{endAddress}</div>
          </div>
        </div>
      </div>
      <div>{distance}</div>
    </div>
  );
}

export default function DrivingHistoryList() {
  return (
    // Container
    <div className="mx-auto w-full max-w-[240px] overflow-hidden rounded-[13px] bg-white">
      {/* Header */}
      <div
        className="flex justify-center p-[10px] text-[15px] font-bold text-white"
        style={{ backgroundColor: colors.blue }}
      >
        January 1st
      </div>
      {/* Subheader */}
      <div
        className="flex justify-between border-b border-solid p-[11px] text-[12px] font-bold"
        style={{ borderColor: colors.grayLight7 }}
      >
        <div>2 Trips</div>
        <div>15.2 mi</div>
      </div>
      <Trip
        startTime="4:23 PM"
        endTime="3:34 PM"
        startAddress="27933 Jacobson Lake"
        endAddress="10930 Lucie Meadow "
        distance="12.1 mi"
      />
      <Trip
        startTime="9:24 AM"
        endTime="9:12 AM"
        startAddress="10930 Lucie Meadow"
        endAddress="1917 Lou Mount"
        distance="12.1 mi"
      />
    </div>
  );
}
